import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectShowInvalids, selectOrderedUnitsIsEmpty } from '@store/partners-order/selectors';
import DogsSizesGrid from '@pages/partners-order/sizes-units/DogsSizesGrid';
import CatsCollarSizesGrid from '@pages/partners-order/sizes-units/CatsCollarSizesGrid';
import CatsSizesGrid from '@pages/partners-order/sizes-units/CatsSizesGrid';


const SizesUnits = () => {
	const { t } = useTranslation('forms');

	const showInvalids = useSelector(selectShowInvalids);
	const orderedUnitsIsEmpty = useSelector(selectOrderedUnitsIsEmpty);

	return (
		<div className='sizes-units-section'>

			<div className='dogs-sizes'>
				<label className='units-label'>
					{t('sizesUnits.dogLabel')}{showInvalids && orderedUnitsIsEmpty &&
						<p className='form-invalid'>{' ' + t('validation.partnersEmptyOrder')}</p>}
				</label>

				<p>{t('inputLabels.size')}</p>

				<DogsSizesGrid />
			</div>

			
			<div className='cats-sizes'>
				<label className='units-label'>
					{t('sizesUnits.catCellarLabel')}
				</label>

				<p>{t('inputLabels.size')}</p>

				<CatsCollarSizesGrid />
			</div>

			
			<div className='cats-sizes'>
				<label className='units-label'>
					{t('sizesUnits.catProbeLabel')}
				</label>

				<p>{t('inputLabels.size')}</p>

				<CatsSizesGrid />
			</div>

			<p className='test-samples-warning'>{t('sizesUnits.testSamplesWarning')}</p>

		</div>
	);
};

export default SizesUnits;